"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _label = _interopRequireDefault(require("../label"));
var _icon = _interopRequireDefault(require("../icon"));
var _Select = _interopRequireDefault(require("../select/v2/Select"));
var _Definition = _interopRequireDefault(require("./Definition.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Definition = function Definition(_ref) {
  var title = _ref.title,
    disabled = _ref.disabled,
    canDelete = _ref.canDelete,
    onDelete = _ref.onDelete,
    selectLabel = _ref.selectLabel,
    selectOptions = _ref.selectOptions,
    onChangeOption = _ref.onChangeOption,
    option = _ref.option;
  return /*#__PURE__*/_react["default"].createElement(_Definition["default"], {
    className: "definition"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "detail-title"
  }, /*#__PURE__*/_react["default"].createElement(_label["default"], {
    className: "detail-title-label"
  }, title), canDelete && /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    id: "delete-detail",
    icon: "ion-trash-b",
    size: 20,
    "aria-label": "Delete",
    className: "delete-icon",
    onClick: onDelete,
    disabled: disabled
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "detail-row"
  }, /*#__PURE__*/_react["default"].createElement(_label["default"], {
    htmlFor: "select-fied-input"
  }, selectLabel), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    onChange: onChangeOption,
    options: selectOptions,
    isSearchable: true,
    value: option,
    placeholder: "Select Field",
    disabled: disabled
  })));
};
Definition.propTypes = {
  title: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  canDelete: _propTypes["default"].bool,
  onDelete: _propTypes["default"].func,
  selectLabel: _propTypes["default"].string,
  selectOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    isDisabled: _propTypes["default"].bool,
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  })),
  onChangeOption: _propTypes["default"].func,
  option: _propTypes["default"].shape({
    isDisabled: _propTypes["default"].bool,
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  })
};
Definition.defaultProps = {
  disabled: false,
  canDelete: false,
  onDelete: _utils.noop,
  selectLabel: '',
  selectOptions: [],
  onChangeOption: _utils.noop,
  option: {}
};
var _default = exports["default"] = Definition;